import { Component, OnInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { DataManager } from '@syncfusion/ej2-data';
import { TranslateService } from '@ngx-translate/core';
import { saveAs as importedSaveAs } from "file-saver";
import { HttpService } from '../../services/http.service';
import { HelperService } from '../../services/helper.service';
import { NotifyService } from '../../services/notify.service';
import { SidebarService } from '../../sidebar/sidebar.service';
import { AuthenService } from '../../services/authen.service';
import { Router } from '@angular/router';
import { UrlParams } from '../../helpers/url-params';
import { MasterBase } from '../../base/master-base';
import * as AppConst from '../../data/test.data';
import { MyImportFileDialogComponent } from "../../dialogs/my-import-file-dialog/my-import-file-dialog";
import { ChangeEventArgs } from '@syncfusion/ej2-buttons';
import { Util } from '../../helpers/global.util';

@Component({
    selector: 'ffm-matrix-page',
    templateUrl: './ffm-matrix-page.html',
})
export class FFMMatrixPageComponent extends MasterBase implements OnInit, OnDestroy {
    @ViewChild('dlgImport') dlgImport: MyImportFileDialogComponent;
    waiting: boolean = false;
    areaMList: any[] = [];
    areaIdsSelected: string[] = [];
    nameValueFields: Object = { text: 'Name', value: 'Value' };    

    constructor(auth: AuthenService, http: HttpService, helper: HelperService, notify: NotifyService, translate: TranslateService, private sidebar: SidebarService, private router: Router) {
        super(auth, http, helper, notify, translate);

        this.searchOpts = [
            { label: 'None', value: 0 },
            { label: 'HS User Code', value: 1 },
            { label: 'FFM User Code', value: 2 },
            { label: 'Area', value: 3 }
        ]
    }

    ngOnDestroy() {
    }

    ngOnInit() {
        this.onSearch();
        this.searchAreas('');
    }

    onSearch() {
        let params = new UrlParams();
        params.add('hsUserCode', this.searchType == 1 ? (this.searchValue == null ? '' : this.searchValue) : '');
        params.add('ffmUserCode', this.searchType == 2 ? (this.searchValue == null ? '' : this.searchValue) : '');
        params.add('areaIds', this.searchType == 3 ? Util.array2String(this.areaIdsSelected) : '');

        this.gridData = this.http.getByManager(`api/Util/GetFFMPage?${params.toString()}`, this.auth);
    }

    onExport() {
        let params = new UrlParams();
        params.add('hsUserCode', this.searchType == 1 ? (this.searchValue == null ? '' : this.searchValue) : '');
        params.add('ffmUserCode', this.searchType == 2 ? (this.searchValue == null ? '' : this.searchValue) : '');
        params.add('areaIds', this.searchType == 3 ? Util.array2String(this.areaIdsSelected) : '');

        this.waiting = true;
        this.http.download(`api/Util/ExportFFMMatrix?${params.toString()}`, res => {
            let fileNameExport = 'CRM_FFMMatrix.xlsx';
            importedSaveAs(res, fileNameExport);
            this.waiting = false;
        });
    }

    onImport() {
        this.dlgImport.show('api/Util/ImportFFMMatrix', null, res => {
            this.grid.refresh();
        });
    }

    onDelete(id: number) {
        this.helper.confirm('Are you sure you want to remove this item ?', () => {
            this.http.delete(`api/Util/RemoveFFMMatrix/${id}`, res => {
                this.grid.refresh();
            });
        });
    }

    searchAreas(text: string) {
        this.http.get(`api/Util/SearchAllAreaList?text=${text}`, res => {
            let tempList : any[] = [];
            res.Result.forEach(p => tempList.push({ 'Name': p.Name, 'Value': p.Value }));
            this.areaMList = tempList;
            //console.log(this.requestTypeMList);
        });
    }

    onCheckAllArea(evt: ChangeEventArgs) {        
        if (evt.checked) {
            this.areaIdsSelected = [];
            this.areaMList.forEach(p => {
                this.areaIdsSelected.push(p.Value);
            });
        } else {
            this.areaIdsSelected = [];
            console.log(this.areaIdsSelected);
        }
        //this.ngRefresh();
    }
}
